"use client";

import Image from "next/image";
import { useState } from "react";

interface ImageItem {
  src: string;
  alt: string;
  title?: string;
}

interface ImageGalleryProps {
  images: ImageItem[];
  className?: string;
}

export default function ImageGallery({
  images,
  className = "",
}: ImageGalleryProps) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  if (images.length === 0) {
    return null;
  }

  return (
    <div className={`w-full ${className}`}>
      {/* 主图 */}
      <div className="relative aspect-video w-full mb-4 rounded-lg overflow-hidden bg-gray-100">
        <Image
          src={images[selectedIndex].src}
          alt={images[selectedIndex].alt}
          fill
          className="object-cover"
          priority={selectedIndex === 0}
          unoptimized
        />
        {images[selectedIndex].title && (
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
            <p className="text-white font-medium">{images[selectedIndex].title}</p>
          </div>
        )}
      </div>

      {/* 缩略图列表 */}
      {images.length > 1 && (
        <div className="grid grid-cols-4 gap-2">
          {images.map((image, index) => (
            <button
              key={index}
              onClick={() => setSelectedIndex(index)}
              className={`relative aspect-video rounded-md overflow-hidden border-2 transition-all ${
                selectedIndex === index
                  ? "border-black scale-105"
                  : "border-transparent hover:border-gray-300"
              }`}
            >
              <Image
                src={image.src}
                alt={image.alt}
                fill
                className="object-cover"
                unoptimized
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

